export const toCurrency = (value: number) => {
	if (typeof value !== 'number') {
		return value;
	}

	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: 2,
	});

	return formatter.format(value);
};
